import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { getSubCategories } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import SubCategoriesCRUD from "./SubCategoriesCRUD";


const SubCategoriesScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [selected, setSelected] = useState(null)
  
  const getInfo = async () => {
    setLoading(true);
    let result = await getSubCategories();
    setData(result);
    setLoading(false);
  };

  const colums = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdSubCategoria",
      className: "XXsmall",
      frozen: true,
      hidden: userAuth?.IdRol === 1,
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data);
        setShowDialog(true);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: "count",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data);
        setShowDialog(true);
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoSubCategoria",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data);
        setShowDialog(true);
      },
      className: "Xsmall",
    },
    {
      header: "Sub Categoría",
      headerEn: "Sub Category",
      field: "SubCategoria",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data);
        setShowDialog(true);
      },
      className: "large",
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "Descripcion",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data);
        setShowDialog(true);
      },
      className: "medium",
      flex: 1,
      minWidth: 200,
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "Categoria",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data);
        setShowDialog(true);
      },
      className: "small",
    },
    {
      header: "Usuario Creación",
      headerEn: "User Create",
      field: "UserNameCreate",
      className: "medium",
    },
    {
      header: "Usuario Edición",
      headerEn: "User Edit",
      field: "UserNameEdit",
      className: "medium",
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdType",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if (rowData?.IdSubCategoria) {
              setSelected(rowData);
              setShowDialog(true);
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: data,
    showModal: () => {}
  }

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "subcategoria", config.language));
  }, []);
  
  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "subcategoria", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            <Button
              icon="pi pi-plus"
              tooltip="Nuevo"
              onClick={(e) => {
                setShowDialog(true)
                setSelected(null)
              }}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />
            <div style={{ height: '87vh' }}>
              <AgGrid table={table} />
            </div>
          </div>
        }
      />

      {showDialog && (
        <SubCategoriesCRUD
          showDialog={showDialog}
          selected={selected}
          setSelected={setSelected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
        />
      )}

    </div>
  );
};

export default SubCategoriesScreen;
